module.exports = __webpack_public_path__ + "img/vehiclerosso.886daa33.png";